/**
 * Registers the **TypeScript fallback** mesh kernels behind {@link meshKernels}.
 *
 * Production prefers Wasm (`enableWasmMeshKernels` / editor mount / exporters).
 * TS implementations remain only for soft-fail and direct algorithm unit tests.
 *
 * Do not import stroke/fill triangulation entry points from `strokeMesh` /
 * `pathNodes` in new production code — use `meshKernels` wrappers.
 */
import { registerTsMeshKernelImpl } from "./meshKernels";
import { tsMeshKernelFallback } from "./tsMeshKernelsFallback";

registerTsMeshKernelImpl(tsMeshKernelFallback);
